import { PAY_RATE_TYPES } from '@/lib/constants/payRateTypes'

let getPayRateTypeLabel = (payRateTypeId) => {
  return PAY_RATE_TYPES[payRateTypeId]
}

export default getPayRateTypeLabel
